import { ExamineeStatus } from '../../ExamineeList.types';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ReactComponent as CardCompletedIcon } from '../../../../assets/icons/cardCompletedIcon.svg';
import TooltipOne from '../../../../components/TooltipOne/TooltipOne.component';

export const getCandidateCardStatus = (type: ExamineeStatus, tooltip?: boolean, title?: boolean): JSX.Element => {
  if (!tooltip) {
    switch (type) {
      case ExamineeStatus.Completed:
        return (
          <div style={{display: 'inline-flex'}}>
            <CardCompletedIcon style={{ marginRight: -2, marginLeft: 2 }} />{' '}
            {title ? <span style={{paddingLeft: '5px'}}> Karta kompletna</span> : null}
          </div>
        );
      case ExamineeStatus.Incomplete:
        return (
          <>
            <InfoOutlinedIcon style={{ color: '#FF9A02', width: 18, height: 18, marginTop: 6 }} />
            {title ? 'Karta niekompletna' : null}
          </>
        );
      case ExamineeStatus.Empty:
        return (
          <div style={{display: 'inline-flex'}}>
            <ReportGmailerrorredIcon style={{ color: '#BC0000', width: 18, height: 18 }} />
            {title ? <span style={{paddingLeft: '5px'}}> Brak karty zdającego</span>  : null}
          </div>
        );
    }
  } else {
    switch (type) {
      case ExamineeStatus.Completed:
        return (
          <TooltipOne placement={'top'} title={'Karta kompletna'}>
            <CardCompletedIcon style={{ marginRight: -2, marginLeft: 2, marginTop: 1 }} />
          </TooltipOne>
        );
      case ExamineeStatus.Incomplete:
        return (
          <TooltipOne placement={'top'} title={'Karta niekompletna'}>
            <InfoOutlinedIcon style={{ color: '#FF9A02', width: 18, height: 18, marginTop: 6 }} />
          </TooltipOne>
        );
      case ExamineeStatus.Empty:
        return (
          <TooltipOne placement={'top'} title={'Brak karty zdającego'}>
            <ReportGmailerrorredIcon style={{ color: '#BC0000', width: 18, height: 18, marginTop: 6 }} />
          </TooltipOne>
        );
    }
  }
};
